import { ItemStatus } from '@/constants/item'
import { ItemsResponse } from '@/features/items/types/item'
import { apiClient } from '@/lib/api/api-client'
import type { Product, ProductCategory } from '../types/product'

export const productApi = {
  getProducts: (params?: { categoryId?: string; excludeDepartmentId?: string; search?: string }) => {
    return apiClient.get<Product[]>(`products/`, { params })
  },

  getProduct: (id: string) => {
    return apiClient.get<Product>(`products/${id}`)
  },

  createProduct: (payload: any) => {
    return apiClient.post<Product>(`products`, payload)
  },

  updateProduct: (id: string, payload: any) => {
    return apiClient.put<Product>(`products/${id}`, payload)
  },

  deleteProduct: (id: string) => {
    return apiClient.delete<void>(`products/${id}`)
  },

  getProductItems: (id: string, params?: { status?: ItemStatus; search?: string }) => {
    return apiClient.get<ItemsResponse>(`products/${id}/items`, { params })
  },

  getProductCategories: (params?: { IsDeleted?: boolean }) => {
    return apiClient.get<ProductCategory[]>(`products/categories/`, { params })
  },

  createProductCategory: (payload: any) => {
    return apiClient.post<ProductCategory>(`products/categories/`, payload)
  },

  updateProductCategory: (id: string, payload: any) => {
    return apiClient.put<ProductCategory>(`products/categories/${id}`, payload)
  },

  deleteProductCategory: (id: string) => {
    return apiClient.delete<void>(`products/categories/${id}`)
  },
}
